import qrcode from './qrcode.vue'

export default qrcode
